"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.load.error': 'Error al cargar datos de ranura',
};
